import { appConfig } from "../../config/config";
import { apiService } from "../api.service";

import CookieService from "../CookieService";

export const SignOut= async() => {
    await apiService.apiRequest<any>("post", `auth/logout`);
    CookieService.removeCookie(appConfig.authAccessToken)
}
